import login from './login';
import logout from './logout';
import watchOtherLogin from './otherLogin';

const authActions = [login, logout, watchOtherLogin];

export default authActions;
